import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SETTINGS } from '../../../../core/configs/common.settings';
import { FilesService } from '../../../../core/services/files.service';
import { InventoryService } from '../../../../core/services/inventory.service';
import { AppUtils } from '../../../../core/configs/app.utils';
import { ClientService } from '../../../../core/services/client.service';
import { ProjectService } from '../../../../core/services/project.service';
import { CompanyService } from '../../../../core/services/company.service';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { GooglePlaceApiService } from '../../../../core/services/google-place-api.service';
import { JobService } from '../../../../core/services/job.service';
import { ItemService } from '../../../../core/services/item.service';
import { UserService } from '../../../../core/services/user.service';
import { getConvertedTimeOptions } from '../../../../core/utli-functions/time';
import { PermissionService } from '../../../../core/services/permission.service';
import { PERMISSION } from '../../../../core/configs/permissions.config';
import * as moment from "moment";
import { requiredMissing } from '../form-kit/required-missing';
import {
  INVENTORY_HIRE_STATUSES,
  INVENTORY_STATUS_OPTIONS,
  normalizeInventoryStatus,
} from '../revamp/list-kit/list-status-palettes';

interface Options {
  name: string;
  value: string;
}

@Component({
  selector: 'app-add-edit-inventory-popup',
  templateUrl: './add-edit-inventory-popup.component.html',
  styleUrls: ['./add-edit-inventory-popup.component.scss'],
})
export class AddEditInventoryPopupComponent implements OnInit {
  @Input() basicShow: boolean | undefined;
  @Output() addInventoryPopupOnChange: EventEmitter<any> = new EventEmitter();
  @Input() editInventoryId: string | undefined;
  @Input() editType: string | undefined;
  @Input() statusType: string | undefined;
  /** When set (e.g. list hire status gate), applied after get-one load. */
  @Input() pendingStatus: string | undefined;
  @Input() layout: 'drawer' | 'page' = 'drawer';

  clientPopupName = '';
  data: any[] = [];
  selectedClientName: any = {};
  selectedJobTitle: any = {};

  isFetchingProjectData = false;
  dataLoading = false;
  isDirty = false;
  inventoryForm: FormGroup | any;
  formErrors: any;
  buttonLoading = false;

  dropdownVisible = false;

  droppedBy = [
    { name: 'DroppedBy 01', value: 'DroppedBy 01' },
    {
      name: 'DroppedBy 02',
      value: 'DroppedBy 02',
    },
    { name: 'DroppedBy 03', value: 'DroppedBy 03' },
    { name: 'DroppedBy 04', value: 'DroppedBy 04' },
  ];

  itemTypes: any;

  //attachment Add, Edit and Rename
  maxFileSize = 100000000;
  renameAttachmentForm: FormGroup | any;
  renameAttachmentFormErrors: any;
  renameAttachmentDialog = false;
  renameAttachmentIndex = 0;
  uploadedFiles: any[] = [];
  isFileUploading = false;
  baseAPI = SETTINGS.BASE_API;
  isFileUploaded = false;

  //Client select
  showCompanyField = true;
  isCompanyDisabled = false;
  isTitleDisabled = false;
  companyNameOptions: any[] = [];
  jobTitleOptions: any[] = [];
  company: any = '';
  title: string | null = null;
  selectedCompanyName = '';
  getClientsLoading = false;
  getJobTitleLoading = false;
  setProjectField = false;
  jobForm: FormGroup | any;
  clientProjectsOption: any[] = [];
  clientsData: any[] = [];
  titlesData: any[] = [];
  staff: Options[] = [];
  clients: any[] = [];
  titles: any[] = [];
  BasicShow: boolean = false;
  isAddItemType: boolean = false;
  isAddContact = true;

  //project select
  isVisibleAddProject = false;
  projectForm: FormGroup | any;
  projectFormErrors: any;
  projectAddressFormErrors: any;
  jobAddressMapLoading = false;
  selectedMapJobLocation = '';
  selectedMapProjectLocation = '';
  projectAddressSelected = false;
  projectAddressMapLoading = false;
  dataFetchingToPopupAddress = false;
  updateProjectLoading = false;
  selectedClientProjects: any[] = [];
  labelStates: { [key: string]: boolean } = {};
  selectedJobTitleLabel: string = '';

  itemNameValue: string = '';
  jobTitleValue: any;
  descriptionValue: string = '';
  dropDateValue: Date | null = null;
  dueDateValue: Date | null = null;
  /** Five CR-35 statuses; Drop off / On site is ON_SITE. */
  statuses = INVENTORY_STATUS_OPTIONS.map(o => ({
    name: o.label,
    value: o.value,
  }));
  selectedStatus: string = '';

  showPopup: boolean = false;
  timeOptions: any = getConvertedTimeOptions();

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private fb: FormBuilder,
    private fileService: FilesService,
    private inventoryService: InventoryService,
    private clientService: ClientService,
    private projectService: ProjectService,
    private companyService: CompanyService,
    private placeApiService: GooglePlaceApiService,
    private jobService: JobService,
    private itemService: ItemService,
    private userService: UserService,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.initInventoryForm();

    this.inventoryForm
      .get('status')
      .valueChanges.subscribe((status: string) => {
        this.selectedStatus = status;
        this.updateFieldRequirements();
      });

    this.selectedStatus =
      this.inventoryForm.get('status').value || this.statuses[0].value;
    this.updateFieldRequirements();

    this.initRenameAttachmentForm();
    this.handleFormDataPopulation();
    this.initProjectForm();

    this.itemNameValue = this.inventoryForm.get('itemName')?.value || '';
    this.descriptionValue = this.inventoryForm.get('description')?.value || '';
    this.dropDateValue = this.inventoryForm.get('dropDate')?.value || null;
    this.dueDateValue = this.inventoryForm.get('dueDate')?.value || null;

    this.inventoryForm
      .get('itemName')
      ?.valueChanges.subscribe((value: string) => {
        this.itemNameValue = value;
      });

    this.inventoryForm
      .get('description')
      ?.valueChanges.subscribe((value: string) => {
        this.descriptionValue = value;
      });

    this.inventoryForm
      .get('dropDate')
      ?.valueChanges.subscribe((value: Date | null) => {
        this.dropDateValue = value;
      });
    this.inventoryForm
      .get('dueDate')
      ?.valueChanges.subscribe((value: Date | null) => {
        this.dropDateValue = value;
      });

    this.inventoryForm
      .get('job')
      ?.valueChanges.subscribe((value: any | null) => {
        this.jobTitleValue = value;
      });
  }

  get needsHireDetails(): boolean {
    return INVENTORY_HIRE_STATUSES.has(
      this.selectedStatus || this.inventoryForm?.get('status')?.value
    );
  }

  private updateFieldRequirements() {
    const dropDate = this.inventoryForm.get('dropDate');
    const dueDate = this.inventoryForm.get('dueDate');
    const dropTime = this.inventoryForm.get('dropTime');
    const client = this.inventoryForm.get('client');
    const job = this.inventoryForm.get('job');

    if (this.needsHireDetails) {
      dropDate?.setValidators(Validators.required);
      dueDate?.setValidators(Validators.required);
      client?.setValidators(Validators.required);
      job?.setValidators(Validators.required);
      dropTime?.clearValidators();
    } else {
      // IN_WAREHOUSE / RETURN_TO_WAREHOUSE — hire fields optional
      dropDate?.clearValidators();
      dueDate?.clearValidators();
      dropTime?.clearValidators();
      client?.clearValidators();
      job?.clearValidators();
    }
    dropDate?.updateValueAndValidity({ emitEvent: false });
    dueDate?.updateValueAndValidity({ emitEvent: false });
    dropTime?.updateValueAndValidity({ emitEvent: false });
    client?.updateValueAndValidity({ emitEvent: false });
    job?.updateValueAndValidity({ emitEvent: false });
    this.inventoryForm.updateValueAndValidity({ emitEvent: false });
  }

  toggleAsteriskVisibility(): void {
    this.itemNameValue = this.inventoryForm.get('itemName')?.value || '';
    // this.jobTitleValue = this.inventoryForm.get('job')?.value || '';
    this.descriptionValue = this.inventoryForm.get('description')?.value || '';
    this.dropDateValue = this.inventoryForm.get('dropDate')?.value || null;
    this.dueDateValue = this.inventoryForm.get('dueDate')?.value || null;
  }

  initProjectForm(): void {
    this.projectForm = this.fb.group({
      name: [null, [Validators.required]],
      address: this.fb.group({
        street: [null],
        suburb: [null],
        state: [null],
        postalCode: [
          null,
          [Validators.compose([Validators.pattern(SETTINGS.REGEX.PHONE.EXP)])],
        ],
        unit: [null],
      }),
    });

    this.projectForm.valueChanges.subscribe((form: any) => {
      this.projectFormErrors = AppUtils.getFormErrors(
        this.projectForm,
        this.projectFormErrors
      );
    });

    this.projectForm.get('address').valueChanges.subscribe((form: any) => {
      this.projectFormErrors = AppUtils.getFormErrors(
        this.projectForm,
        this.projectFormErrors
      );
    });
  }

  selectStatus(value: string): void {
    const next = normalizeInventoryStatus(value) || value;
    const ctrl = this.inventoryForm.get('status');
    if (ctrl?.value === next) return;
    ctrl.setValue(next);
    ctrl.markAsDirty();
  }

  isStatusSelected(value: string): boolean {
    const current = this.inventoryForm?.get('status')?.value;
    if (current === value) return true;
    // Legacy DROP_OFF highlights merged Drop off / On site
    return value === 'ON_SITE' && current === 'DROP_OFF';
  }

  get isWarehouse(): boolean {
    return this.inventoryForm?.get('status')?.value === 'IN_WAREHOUSE';
  }

  get formTitle(): string {
    return (
      this.getHeaderTitle(this.statusType ?? '') ||
      (this.editInventoryId ? 'Edit inventory' : 'Add inventory')
    );
  }

  get missingFields(): string[] {
    if (!this.inventoryForm || this.dataLoading) return [];
    return requiredMissing(this.inventoryForm, [
      { label: 'Item type', control: 'itemType' },
      { label: 'Item name', control: 'itemName' },
      { label: 'Description', control: 'description' },
      {
        label: 'Company',
        when: () => this.needsHireDetails && this.showCompanyField,
        missing: () => !this.company,
      },
      { label: 'Client', control: 'client', when: () => this.needsHireDetails },
      { label: 'Job', control: 'job', when: () => this.needsHireDetails },
      {
        label: 'Drop date',
        control: 'dropDate',
        when: () => this.needsHireDetails,
      },
      {
        label: 'Due date',
        control: 'dueDate',
        when: () => this.needsHireDetails,
      },
    ]);
  }

  get canSave(): boolean {
    return (
      !this.buttonLoading &&
      !this.isFileUploading &&
      this.inventoryForm?.valid &&
      this.missingFields.length === 0
    );
  }

  get canAddClient(): boolean {
    return (
      !!this.company &&
      !this.isCompanyDisabled &&
      this.permissionService.hasPermission(PERMISSION.CLIENT_ADD)
    );
  }

  save(): void {
    if (!this.canSave) {
      this.inventoryForm.markAllAsTouched();
      return;
    }
    if (this.editInventoryId) this.updateItem();
    else this.addItem();
  }

  onCompanySelect(value: string | null): void {
    if (!value || value === this.company) return;
    this.companyOnChange(value);
  }

  showClientPopup(name = ''): void {
    this.clientPopupName = name;
    this.BasicShow = true;
  }

  private reloadClients(selectId?: string): void {
    if (!this.company) return;
    this.getClientsLoading = true;
    this.clientService.getAllClients({ company: this.company }).subscribe({
      next: (res: any) => {
        this.clientsData = res || [];
        this.clients = this.clientsData.map((cl: any) => ({
          label: cl?.type === 'PERSONAL' ? `${cl.firstname} ${cl.lastname}` : cl?.companyName,
          value: cl._id,
        }));
        this.getClientsLoading = false;
        if (selectId) {
          const ctrl = this.inventoryForm.get('client');
          ctrl.markAsDirty();
          ctrl.setValue(selectId);
        }
      },
      error: () => {
        this.getClientsLoading = false;
      },
    });
  }

  initRenameAttachmentForm() {
    this.renameAttachmentForm = this.fb.group({
      fileName: [
        '',
        Validators.compose([Validators.required, this.confirmationValidator]),
      ],
      fileExtension: [{ value: '', disabled: true }, Validators.required],
    });
    this.renameAttachmentForm.valueChanges.subscribe(() => {
      this.renameAttachmentFormErrors = AppUtils.getFormErrors(
        this.renameAttachmentForm,
        this.renameAttachmentFormErrors
      );
    });
  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else {
      for (let i = 0; i < control.value.length; i++) {
        const letter = control.value[i];
        if (letter === '.' || letter === '/') {
          return { confirm: true, error: true };
        }
      }
    }
    return {};
  };

  onAddClientPopupChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.BasicShow = event.value;
        break;
      case 'resp':
        this.BasicShow = false;
        this.reloadClients(event.value?._id);
    }
  }

  handleFormDataPopulation(): void {
    this.setProjectField = false;
    this.dataLoading = true;
    this.inventoryForm.controls['client'].disable();
    this.companyNameOptions = [];
    this.getItems();

    this.companyService.getAllCompanies().subscribe(
      (res: any) => {
        const companies = res as any;
        companies.forEach((com: any) => {
          this.companyNameOptions.push({ label: com.name, value: com._id });
        });

        if (this.companyNameOptions.length === 0) {
          this.inventoryForm.controls['client'].enable();
          this.isCompanyDisabled = false;
        }

        if (this.editInventoryId) {
          if (this.editType === 'normalEdit') {
            this.inventoryForm.controls['client'].enable();
            this.showCompanyField = true;
            this.setInventoryValue();
          }
          if (this.editType === 'clientEdit') {
            this.isCompanyDisabled = true;
            this.inventoryForm.controls['job'].disable();
            this.setInventoryValue();
          }
        } else if (localStorage.getItem(SETTINGS.COMPANY)) {
          this.getClientsLoading = true;
          this.clients = [];
          this.company = localStorage.getItem(SETTINGS.COMPANY);
          this.showCompanyField = false;
          const com = this.companyNameOptions.find(
            co => co.value === this.company
          );
          this.selectedCompanyName = com?.label;

          this.getStaff();

          this.clientService.getAllClients({ company: this.company }).subscribe(
            res => {
              this.clientsData = res as any;
              const clients = res as any;
              clients.forEach((cl: any) => {
                this.clients.push({
                  label:
                    cl?.type === 'PERSONAL'
                      ? `${cl.firstname} ${cl.lastname}`
                      : cl?.companyName,
                  value: cl._id,
                });
              });
              this.getClientsLoading = false;
              this.inventoryForm.controls['client'].enable();
              this.dataLoading = false;
            },
            (error: any) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: `${
                  error?.error?.message ? error?.error?.message : 'Error'
                }`,
              });
              this.getClientsLoading = false;
            }
          );
        } else {
          this.showCompanyField = true;
          this.dataLoading = false;
        }
      },
      (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${error?.error?.message ? error?.error?.message : 'Error'}`,
        });
      }
    );
  }

  private endInventoryEditLoading(): void {
    this.dataLoading = false;
  }

  /** get-one may return populated docs; form + secondary APIs need string ids. */
  private unwrapId(value: unknown): string | null {
    if (value == null || value === '') return null;
    if (typeof value === 'object' && value !== null && '_id' in (value as object)) {
      return String((value as { _id: unknown })._id);
    }
    return String(value);
  }

  private applyInventoryEditPayload(res: any): void {
    const clientId = this.unwrapId(res?.client);
    const companyId = this.unwrapId(res?.company);
    const itemTypeId = this.unwrapId(res?.itemType);
    const jobId = this.unwrapId(res?.job);
    const droppedById = this.unwrapId(res?.droppedBy);

    if (companyId) {
      this.company = companyId;
    }

    this.inventoryForm.patchValue({
      ...res,
      itemType: itemTypeId || '',
      job: jobId,
      client: clientId,
      droppedBy: droppedById,
      itemNo: res?.itemNo ?? '',
      notes: res?.notes ?? '',
      quantity: res?.quantity ?? null,
      warehouseLocation: res?.warehouseLocation ?? '',
    });

    if (res?.dropDate) {
      this.inventoryForm.get('dropDate')?.patchValue(new Date(res.dropDate));
    }
    if (res?.dueDate) {
      this.inventoryForm.get('dueDate')?.patchValue(new Date(res.dueDate));
    }
    if (res?.dropTime) {
      const dropTime = res.dropTime;
      this.inventoryForm
        .get('dropTime')
        ?.patchValue(
          typeof dropTime === 'string' && /^\d{1,2}:\d{2}/.test(dropTime)
            ? dropTime
            : new Date(dropTime)
        );
    }

    this.uploadedFiles = res?.attachments || [];
    this.applyPendingStatusIfAny();
  }

  private applyPendingStatusIfAny(): void {
    const next = this.pendingStatus;
    if (!next) return;
    this.selectedStatus = next;
    this.inventoryForm.get('status')?.setValue(next, { emitEvent: true });
    this.updateFieldRequirements();
    this.pendingStatus = undefined;
  }

  setInventoryValue() {
    this.dataLoading = true;
    this.inventoryService.getOneInventoryId(this.editInventoryId).subscribe({
      next: (res: any) => {
        const companyId = this.unwrapId(res?.company);
        const clientId = this.unwrapId(res?.client);
        this.company = companyId;
        this.getStaff();
        this.clients = [];
        this.clientProjectsOption = [];

        if (!clientId) {
          this.applyInventoryEditPayload(res);
          this.endInventoryEditLoading();
          return;
        }

        this.clientService.getAllClients({ company: companyId }).subscribe({
          next: (cli: any) => {
            this.clientsData = cli as any;
            const clients = Array.isArray(cli) ? cli : [];
            clients.forEach((cl: any) => {
              this.clients.push({
                label:
                  cl?.type === 'PERSONAL'
                    ? `${cl.firstname} ${cl.lastname}`
                    : cl?.companyName,
                value: cl._id,
              });
            });

            this.projectService.getProjectsByClient(clientId).subscribe({
              next: (project: any) => {
                const projects = Array.isArray(project) ? project : [];
                projects.forEach((pro: any) => {
                  this.clientProjectsOption.push({
                    label: pro.name,
                    value: pro._id,
                  });
                });
                this.applyInventoryEditPayload(res);
                this.endInventoryEditLoading();
              },
              error: () => {
                // Projects optional for form; still apply payload so drawer opens
                this.applyInventoryEditPayload(res);
                this.endInventoryEditLoading();
              },
            });
          },
          error: () => {
            this.applyInventoryEditPayload(res);
            this.endInventoryEditLoading();
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error occurred while fetching clients',
            });
          },
        });
      },
      error: (error: any) => {
        this.endInventoryEditLoading();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.message || 'Could not load inventory item',
        });
      },
    });
  }

  companyOnChange(value: string): void {
    this.company = value === '' ? null : value;

    if (this.companyNameOptions.length > 0) {
      const com = this.companyNameOptions?.find(co => co.value === value);
      this.selectedCompanyName = com?.label;
    }

    this.getClientsLoading = true;
    this.setProjectField = false;
    this.inventoryForm.get('client')?.reset();
    this.inventoryForm.get('client')?.disable();
    this.clients = [];
    this.clientProjectsOption = [];
    this.getStaff();

    this.clientService.getAllClients({ company: this.company }).subscribe(
      res => {
        this.getClientsLoading = false;
        this.inventoryForm.controls['client'].enable();
        this.clientsData = res;

        const clients = res as any;
        clients.forEach((cl: any) => {
          this.clients.push({
            label:
              cl?.type === 'PERSONAL'
                ? `${cl.firstname} ${cl.lastname}`
                : cl?.companyName,
            value: cl._id,
          });
        });
      },
      (error: any) => {
        this.getClientsLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${
            error?.error?.message
              ? error?.error?.message
              : 'Error occurred while fetching clients'
          }`,
        });
      }
    );
  }

  initInventoryForm(): void {
    this.inventoryForm = this.fb.group({
      itemType: ['', Validators.required],
      job: [null],
      itemName: ['', Validators.required],
      itemNo: [''],
      description: ['', Validators.required],
      notes: [''],
      quantity: [null],
      warehouseLocation: [''],
      dropDate: [null],
      dueDate: [null],
      dropTime: [null],
      client: [null],
      title: [null],
      status: [this.selectedStatus || 'IN_WAREHOUSE', Validators.required],
      droppedBy: [null],
    });

    this.inventoryForm.get('client').valueChanges.subscribe((val: any) => {
      if (this.inventoryForm.get('client').dirty) {
        this.setProjectField = false;
        this.getJobsByClient({
          client: this.inventoryForm.get('client').getRawValue(),
        });
      } else {
        this.getJobsByClient({
          client: this.inventoryForm.get('client').getRawValue(),
        });
      }
      this.selectedClientName = this.clients.find(cl => cl.value === val);
    });
  }

  getJobTitleLabel(value: any): string {
    const selectedJob = this.jobTitleOptions.find(job => job.value === value);
    return selectedJob ? selectedJob.label : '';
  }

  getJobsByClient(filter: any) {
    this.jobService.getFilteredClientById(filter).subscribe((res: any) => {
      const jobs = res as any;
      this.jobTitleOptions = [];
      this.jobTitleOptions = jobs.map((job: any) => ({
        label: [
          job?.refNo,
          job?.title,
          job?.startDateAndTime ? moment(job.startDateAndTime).format('DD/MM/YYYY') : null,
        ]
          .filter(Boolean)
          .join(' - '),
        value: job._id,
      }));
    });
  }

  clientProjectSet(cliId: any, proId?: string, iniInit?: boolean): void {
    this.isFetchingProjectData = true;
    this.clientProjectsOption = [];
    this.projectService.getProjectsByClient(cliId).subscribe(
      (res: any) => {
        if (res?.length > 0) {
          res?.map((pro: any) => {
            this.clientProjectsOption.push({
              label: pro.name,
              value: pro._id,
            });
          });
        }
        this.isFetchingProjectData = false;
        this.setProjectField = true;
      },
      (e: any) => {
        this.isFetchingProjectData = false;
        this.setProjectField = true;
      }
    );
  }

  onAttachmentUpload(event: any, uploader: { clear: () => void }): void {
    this.onUpload(event);
    uploader.clear();
  }

  onUpload(event: any) {
    for (const file of event.files) {
      this.isFileUploading = true;
      this.fileService.postFile(file).subscribe(
        res => {
          this.uploadedFiles.push({
            originalFileName: file.name,
            url: res.url,
          });
          // this.isFileUploaded = true;

          if (this.editInventoryId) {
            this.inventoryService
              .updateInventory({
                _id: this.editInventoryId,
                attachments: this.uploadedFiles,
              })
              .subscribe();
          } else {
            this.isDirty = false;
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Attachments have been added!',
          });
          this.isFileUploading = false;
        },
        (error: any) => {
          this.isFileUploading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${
              error?.error?.message ? error?.error?.message : 'Error'
            }`,
          });
        }
      );
    }
  }

  removeFile(event: Event, index: number): void {
    this.confirmationService.confirm({
      key: 'removeFile',
      message: `Are you sure you want to delete this attachment?`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.uploadedFiles.splice(index, 1);
        // this.isFileUploaded = this.uploadedFiles.length > 0;

        if (this.editInventoryId) {
          this.inventoryService
            .updateInventory({
              _id: this.editInventoryId,
              attachments: this.uploadedFiles,
            })
            .subscribe();
        } else {
          this.isDirty = false;
        }
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Attachment has been deleted!',
        });
      },
      reject: () => {},
    });
  }

  getIcon(file: string): string {
    return AppUtils.getUrlExtension(file);
  }

  renameAttachment(index: any) {
    this.renameAttachmentIndex = index;
    const selectedFileName = this.uploadedFiles[index].originalFileName;
    const fileNameParts = selectedFileName.split('.');
    this.renameAttachmentForm.patchValue({
      fileName: fileNameParts[0],
      fileExtension: fileNameParts[fileNameParts.length - 1],
    });
    this.renameAttachmentDialog = true;
  }

  dialogClose() {
    if (this.isDirty || this.inventoryForm?.dirty) {
      this.confirmationService.confirm({
        key: 'canDeactivateConfirmDialog',
        message: `Are you sure you want to discard all unsaved changes?`,
        icon: 'pi pi-exclamation-triangle',
        header: 'Discard Changes?',
        acceptLabel: 'Discard Changes',
        acceptIcon: 'pi pi-times',
        accept: () => {
          this.closeInventoryForm();
        },
        rejectLabel: 'Keep Editing',
        rejectIcon: 'pi pi-check',
        reject: () => {},
      });
    } else {
      this.closeInventoryForm();
    }
  }

  closeInventoryForm(): void {
    this.addInventoryPopupOnChange.emit({ name: 'isVisible', value: false });
    this.basicShow = false;
  }

  addItem(): void {
    const formData = this.inventoryForm.getRawValue();
    formData.company = this.company || null;

    formData.status = normalizeInventoryStatus(formData.status) || formData.status;
    // Keep company so company-scoped list shows warehouse items; clear hire fields only.
    const modifyData =
      formData.status === 'IN_WAREHOUSE'
        ? {
            job: null,
            droppedBy: null,
            client: null,
            dropDate: null,
            dueDate: null,
            dropTime: null,
          }
        : {};

    this.buttonLoading = true;

    this.inventoryService
      .createInventory({
        ...formData,
        ...modifyData,
        attachments: this.uploadedFiles,
      })
      .subscribe(
        () => {
          this.inventoryForm.reset();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Inventory Created Successfully',
          });
          this.buttonLoading = false;
          this.closeInventoryForm();
        },
        e => {
          this.buttonLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to Create Task',
          });
        }
      );
  }

  addItemType(): void {
    this.isAddItemType = true;
  }

  updateItem(): void {
    const formData = this.inventoryForm.getRawValue();

    formData._id = this.editInventoryId;
    formData.company = this.company || null;
    formData.status = normalizeInventoryStatus(formData.status) || formData.status;

    // Keep company so company-scoped list shows warehouse items; clear hire fields only.
    const modifyData =
      formData.status === 'IN_WAREHOUSE'
        ? {
            job: null,
            droppedBy: null,
            client: null,
            dropDate: null,
            dueDate: null,
            dropTime: null,
          }
        : {};

    this.buttonLoading = true;

    this.inventoryService
      .updateInventory({ ...formData, ...modifyData })
      .subscribe(
        () => {
          this.inventoryForm.reset();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Updated Successfully',
          });
          this.buttonLoading = false;
          this.closeInventoryForm();
        },
        e => {
          this.buttonLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to Update Task',
          });
        }
      );
  }

  renameAttachmentSave() {
    const editedFileName = this.renameAttachmentForm.getRawValue();
    this.uploadedFiles[this.renameAttachmentIndex].originalFileName =
      editedFileName.fileName + '.' + editedFileName.fileExtension;
    if (this.editInventoryId) {
      this.inventoryService
        .updateInventory({
          _id: this.editInventoryId,
          attachments: this.uploadedFiles,
        })
        .subscribe();
    } else {
      this.isDirty = false;
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Attachment has been renamed!',
    });
    this.renameAttachmentDialog = false;
  }

  renameAttachmentCancel() {
    this.renameAttachmentDialog = false;
  }

  submitProjectData(): void {
    this.updateProjectLoading = true;
    const formData = this.projectForm.getRawValue();
    let payload: any;
    if (this.selectedClientProjects?.length > 0) {
      payload = {
        client: this.jobForm.get('client').value,
        ...formData,
      };
    } else {
      payload = {
        client: this.jobForm.get('client').value,
        ...formData,
        isFirst: true,
      };
    }
    this.projectService.createProject(payload).subscribe(
      res => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'New Project has been added!',
        });
        this.clientProjectSet(this.jobForm.get('client').value);
        this.projectForm.reset();
        this.isVisibleAddProject = false;
        this.updateProjectLoading = false;
      },
      () => {
        this.updateProjectLoading = false;
      }
    );
  }

  closeAddProject(): void {
    this.projectForm.reset();
    this.isVisibleAddProject = false;
  }

  handleAddressChange(address: Address): void {
    let address_components: any;
    address_components = address?.address_components;
    this.jobAddressMapLoading = false;
    this.jobForm.get('jobLocation').reset();

    address_components?.forEach((component: any) => {
      switch (component?.types[0]) {
        case 'unit':
          this.jobForm.patchValue({
            jobLocation: {
              unitNumber: component?.long_name,
            },
          });
          break;
        case 'route':
          this.jobForm.patchValue({
            jobLocation: {
              street: component?.long_name,
            },
          });
          break;
        case 'locality':
          this.jobForm.patchValue({
            jobLocation: {
              suburb: component?.long_name,
            },
          });
          break;
        case 'administrative_area_level_1':
          this.jobForm.patchValue({
            jobLocation: {
              state: component?.long_name,
            },
          });
          break;
        case 'postal_code':
          this.jobForm.patchValue({
            jobLocation: {
              postalCode: component?.long_name,
            },
          });
          break;
      }
      this.selectedMapJobLocation = '';
    });
    this.placeApiService.placeFetchingInfo.next({
      type: 'component',
      value: false,
    });
    this.projectAddressSelected = false;
  }

  handleProjectAddressChange(address: Address): void {
    let address_components: any;
    address_components = address?.address_components;
    this.projectForm.get('address').reset();
    this.projectAddressMapLoading = false;

    address_components?.forEach((component: any) => {
      switch (component?.types[0]) {
        case 'unit':
          this.projectForm.patchValue({
            address: {
              unit: component?.long_name,
            },
          });
          break;
        case 'route':
          this.projectForm.patchValue({
            address: {
              street: component?.long_name,
            },
          });
          break;
        case 'locality':
          this.projectForm.patchValue({
            address: {
              suburb: component?.long_name,
            },
          });
          break;
        case 'administrative_area_level_1':
          this.projectForm.patchValue({
            address: {
              state: component?.long_name,
            },
          });
          break;
        case 'postal_code':
          this.projectForm.patchValue({
            address: {
              postalCode: component?.long_name,
            },
          });
          break;
      }
      this.placeApiService.placeFetchingInfo.next({
        type: 'popup',
        value: false,
      });
      this.selectedMapProjectLocation = '';
    });
  }

  handleSearchLocationDataChange(event: any): void {
    switch (event.name) {
      case 'component-address':
        this.handleAddressChange(event?.value);
        break;
      case 'popup-address':
        this.handleProjectAddressChange(event?.value);
        break;
    }
  }

  onAddItemChange(event: any): void {
      this.isAddItemType = false;
      if (event.type === 'save'){
         this.inventoryForm.patchValue({itemType: event._id});
          this.getItems();
      }
  }

  getItems(): void {
    this.itemService.getItems().subscribe({
      next: value => {
        this.itemTypes = value;
      },
      error: error => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${error?.error?.message ? error?.error?.message : 'Error'}`,
        });
      },
    });
  }

  getStaff(): void {
    this.staff = [];
    this.userService
      .getFilteredUsers({
        role: '64710bb740de86be5e1135c6',
        active: true,
        company: this.company,
        archived: false,
      })
      .subscribe({
        next: value => {
          const staff = value as any;
          staff.map((st: any) => {
            this.staff.push({
              name: `${st.firstname} ${st.lastname}`,
              value: st._id,
            });
          });
        },
        error: error => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${
              error?.error?.message ? error?.error?.message : 'Error'
            }`,
          });
        },
      });
  }

  getHeaderTitle(type: any): string {
    switch (type) {
      case '':
        return 'Add inventory';

      case 'add':
        return 'Add inventory';

      case 'action':
        return 'Edit inventory';

      case 'table':
        return 'Update status – ' + (this.inventoryForm.get('itemName').value || 'item');

      default:
        return '';
    }
  }
}
